export default class SearchInterfaceController {
  constructor(SearchService, StatsService, $scope, $stateParams, $location, $rcAlerts, $q, $log, $http) {
    'ngInject';
    
    // Raw search term the user enters
    this.searchTerm = "";
    this.searchTermToSearch = "";
    this.spellcheck = "";
    this.initialSearchComplete = false;
    this.infiniteScrollDisabled = false;
    this.filter = "";
    
    this.searchService = new SearchService();
    this.statsService = new StatsService();
    
    // Web Search Globals
    this.webResults = {};
    this.webResults.loading = false;
    
    // Feedback
    this.feedbackModal = {
      open: false
    }
    
    this.$location = $location;
    this.$rcAlerts = $rcAlerts;
    this.$q = $q;
    this.$log = $log;
    this.$scope = $scope;
    
    // Check for query parameters
    this.$onInit = function() {
      if ($stateParams.q != '' && $stateParams.q !== null && typeof $stateParams.q !== "undefined") {
        this.searchTerm = $stateParams.q;
        this.onSearch({searchTerm: this.searchTerm, filter: this.filter, ignoreSpellcheck: false, spellcheckTerm: null})
      }
    };
  }
  
  onSearch(eventObject) {
    this.infiniteScrollDisabled = false;
    this.searchTerm = eventObject.searchTerm;
    this.filter = eventObject.filter;
    const ignoreSpellcheck = eventObject.ignoreSpellcheck;
        
    this.webResults ={};
    this.webResults.loading = true;
    
    this.checkSpelling(this.searchTerm, this.filter).then((spellcheck) => {
      this.spellcheck = spellcheck;
      this.searchTermToSearch = this.searchTerm;
      
      if (ignoreSpellcheck) {
        this.searchTermToSearch = this.spellcheck.searchTerm;
      }
      else if (spellcheck.correctionTerm != "") {
        this.searchTermToSearch = this.spellcheck.correctionTerm;
      }

      this.search(this.searchTermToSearch);
    });
  }
  
  search(searchTermToSearch) {
    this.$location.search({q: searchTermToSearch});
    
    this.statsService.postQueryStatistic(this.searchTerm, searchTermToSearch).catch((message) => {
      this.$log.error("Could not post query statistic: " + message);
    });
    
    // Request web results
    this.searchService.getSolrResults(searchTermToSearch, 'web', '*', 10, this.filter, false).then((data) => {
      this.webResults = data;
    }).catch((message) => {
      this.$rcAlerts.error("Please try refreshing the page", "Search Error:", true, true, "UWS", 10000);
    })
    .finally((done) => {
      this.initialSearchComplete = true;
      this.webResults.loading = false;
    });
  }
  
  checkSpelling(searchTerm, filter) {
    var defer = this.$q.defer();
    let spellcheck = {
      searchTerm: searchTerm,
      correctionTerm: ""
    };
    
    this.searchService.getSolrResults(searchTerm, 'web', '*', 10, filter).then((data) => {
      spellcheck.correctionTerm = data.spellcheck;
      defer.resolve(spellcheck);
    });
    
    return defer.promise;
  }
  
  // This is only used for web results
  onLoadMoreResults() {
    if (this.initialSearchComplete === true && this.webResults.loading === false) {
      
      this.webResults.loading = true;
      this.searchService.getSolrResults(this.searchTerm, 'web', this.webResults.nextCursorMark, 10, this.filter).then((data) => {
        if (this.webResults.nextCursorMark === data.nextCursorMark) {
          this.infiniteScrollDisabled = true;
        }
        
        this.webResults.nextCursorMark = data.nextCursorMark;
        this.webResults.records.push.apply(this.webResults.records, data.records);
        this.webResults.loading = false;
      });
    }
  }
  
  openFeedback() {
    this.feedbackModal.open = true;
  }
  
  closeModal() {
    this.feedbackModal.open = false;
  }
}



// WEBPACK FOOTER //
// ./src/search-interface/search-interface.controller.js